// extracted by mini-css-extract-plugin
export var container = "_tv-0";
export var table = "_tv-2";
export var tableWrapper = "_tv-1";